import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

// Import Components
import Header from './components/header';
import Hero from './components/hero';
import hero from './assets/hero.mp4';
import About from './components/about';
import Banner from './components/Banner';
import Benefits from './components/Benifits';
import Footer from './components/Footer';
import VermiCompostProcess from './components/VermiCompostProcess';
import AboutUsDetailed from './pages/AboutUs';
import GalleryPage from './pages/GalleryPage';
import ContactPage from './pages/ContactPage';
import FuturePlanPage from './pages/FuturePlanPage';
import ScienceStudiesPage from './pages/ScienceStudiesPage';
import PrivacyPolicyPage from './components/PrivacyPolicy';
import TermsAndConditionsPage from './components/Term&conition';
import FAQPage from './components/FAQpage';

// --- NEW COMPONENT TO SCROLL TO TOP ---
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scrolls the window to the top (0, 0 coordinates) whenever the pathname (route) changes.
    window.scrollTo(0, 0);
  }, [pathname]); // Depend on pathname, so it runs on every route change.

  return null; // This component renders nothing, it only handles the side effect (scrolling).
};
// ---------------------------------------

function App() {
  
  // यह क्लास अब केवल होम पेज के लिए इस्तेमाल होगी (या आप इसे हटा सकते हैं)
  const HEADER_PADDING_CLASS = "pt-[120px]"; 
  
  return (
    <Router>
      {/* ScrollToTop component MUST be inside Router */}
      <ScrollToTop /> 
      
      <Header /> 
      <Routes>
        
       
        <Route
          path="/"
          element={
            <main className={HEADER_PADDING_CLASS}>
              <Hero bannerImageUrl="/assets/banner.jpg" videoUrl={hero} />
              <About />
              <Banner />
              <Benefits />
              <VermiCompostProcess />
            </main>
          }
        />

      
        
        <Route 
          path="/about" 
          element={<AboutUsDetailed />} 
        />
        <Route 
          path="/gallery" 
          element={<GalleryPage />} 
        />
        <Route 
          path="/contact" 
          element={<ContactPage />} 
        />
        <Route 
          path="/plan" 
          element={<FuturePlanPage />} 
        />
        <Route 
          path="/study" 
          element={<ScienceStudiesPage />} 
        />
        <Route 
          path="/faq" 
          element={<FAQPage />} 
        />
        <Route 
          path="/privacy" 
          element={<PrivacyPolicyPage />} 
        />
        <Route 
          path="/terms" 
          element={<TermsAndConditionsPage />} 
        />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;